import type { Editor } from '@tiptap/react';

export const getBlockIdFromEditor = (editor: Editor): string | undefined => {
  return editor?.storage?.blockId || undefined;
};

export const resolveBlockId = (editor: Editor, fallbackBlockId?: string | null) => {
  return getBlockIdFromEditor(editor) || fallbackBlockId;
};
